module.exports = __webpack_public_path__ + "img/011-idea-1.5340c1dd.svg";